/*
Don't change this file manually.
It is autogenerated by @plone/registry.
Instead, change the "addons" registration in the app.
*/
import plonevoltoSlate from '@plone/volto-slate';
import voltoBurocomPlone from 'volto-burocom-plone';

const addonsInfo = [{"name":"@plone/volto-slate","version":"19.2.0","isPublishedPackage":true,"isRegisteredAddon":false,"modulePath":"/opt/plone/612-plone/frontend/core/packages/volto-slate/src","hasServerConfig":false,"packageJson":"/opt/plone/612-plone/frontend/core/packages/volto-slate/package.json","basePath":"/opt/plone/612-plone/frontend/core/packages/volto-slate","tsConfigPaths":null,"addons":[]},{"name":"volto-burocom-plone","version":"1.0.0-alpha.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/opt/plone/612-plone/frontend/packages/volto-burocom-plone/src","hasServerConfig":false,"packageJson":"/opt/plone/612-plone/frontend/packages/volto-burocom-plone/package.json","basePath":"/opt/plone/612-plone/frontend/packages/volto-burocom-plone","tsConfigPaths":[null,{"@plone/volto/*":["../../core/packages/volto/src/*"],"volto-burocom-plone/*":["./src/*"]}],"addons":[]}];
export { addonsInfo };

const safeWrapper = (func) => (config) => {
  const res = func(config);
  if (typeof res === 'undefined') {
    throw new Error("Configuration function doesn't return config");
  }
  return res;
}

const load = (config) => {
  const addonLoaders = [plonevoltoSlate, voltoBurocomPlone];
  if(!addonLoaders.every((el) => typeof el === "function")) {
    throw new TypeError(
      'Each addon has to provide a function applying its configuration to the projects configuration.',
    );
  }
  return addonLoaders.reduce((acc, apply) => safeWrapper(apply)(acc), config);
};
export default load;
